import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import { FiAlertTriangle } from 'react-icons/fi';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';
import { RI003Styles } from 'pages/reference-implementation/provisioning/RI003O/style';

export default function ConfirmDialog({ title, primaryBtnText, secondaryBtnText, primaryBtnAction, secondaryBtnAction, content, isModalOpen }) {
    return (
        <Dialog
            open={isModalOpen}
            onClose={secondaryBtnAction}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            data-testid="confirmDialog"
        >
            <DialogContent sx={style.modalWrapper}>
                <Box sx={RI003Styles.confirmDialog.dialogContentBox}>
                    <FiAlertTriangle color={RI003Styles.confirmDialog.IconColor} size={70} />
                    <Typography sx={style.modalTitle} variant="span">
                        {title}
                    </Typography>
                    {content ? <div style={style.modalContent}>{content}</div> : null}
                </Box>

                <Box sx={RI003Styles.confirmDialog.dialogActionBox} gap={2}>
                    <Btn
                        variant="contained"
                        onClick={() => primaryBtnAction()}
                        className="uppercase tracking-wider text-sm custom-btn"
                        // sx={{ textTransform: 'none' }}
                        sx={style.modalSaveButton}
                        data-testid="yes-btn"
                    >
                        {primaryBtnText}
                    </Btn>
                    <Btn
                        variant="outlined"
                        // sx={RI003Styles.confirmDialog.dialogNoBtn}
                        sx={style.modalCancelButton}
                        onClick={() => secondaryBtnAction()}
                        layout="outline"
                        className="uppercase tracking-wider text-sm custom-btn"
                        data-testid="no-btn"
                    >
                        {secondaryBtnText}
                    </Btn>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

ConfirmDialog.propTypes = {
    title: PropTypes.string,
    primaryBtnText: PropTypes.string.isRequired,
    secondaryBtnText: PropTypes.string.isRequired,
    primaryBtnAction: PropTypes.func.isRequired,
    secondaryBtnAction: PropTypes.func.isRequired,
    content: PropTypes.any,
    isModalOpen: PropTypes.bool.isRequired,
};

ConfirmDialog.defaultProps = {
    title: '',
    content: null,
};
